/** Veřejná cesta pozvánky (bez hash) — např. https://svatba.lsadecky.com/pozvanka/muj-slug */
export const INVITATION_PUBLIC_PATH = '/pozvanka';

export function buildPublicInvitationUrl(origin: string, slug: string): string {
  const base = origin.replace(/\/$/, '');
  const s = encodeURIComponent(slug);
  return `${base}${INVITATION_PUBLIC_PATH}/${s}`;
}
